import React from 'react'

import { displayDollars } from '../../../../helpers/displayFormatHelper'
import RadioButton from '../../../../components/radioButton'

export const PaymentOptionsRadio = ({
  paymentOptions,
  selectOption,
  downValue,
  isChecked,
  isMonthlyMembership = false,
}) => {
  const { numberPayment, monthValue, total } = paymentOptions

  function handlePaymentOptionChange(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    const { value } = event.target
    selectOption(value)
  }

  return (
    <div className="payment-options-checkbox">
      <RadioButton
        iconSize="20px"
        checked={isChecked}
        value={String(numberPayment)}
        name="paymentOptions"
        uid={numberPayment}
        onChange={handlePaymentOptionChange}
      />
      <label htmlFor={numberPayment} />
      {isMonthlyMembership ? (
        <>
          Monthly payments ({displayDollars(downValue)} down,{' '}
          {displayDollars(monthValue)}/mo)
        </>
      ) : (
        <>
          {numberPayment} payment{numberPayment > 1 ? 's' : null} (
          {displayDollars(downValue)} down, {displayDollars(monthValue)}/mo,{' '}
          {displayDollars(total)} total)
        </>
      )}
    </div>
  )
}

export default PaymentOptionsRadio
